import React from "react";
import { Link } from "react-router-dom";

// import appg from "../appg";

class Header extends React.Component {
  // loginLogoutLabel = () => {
  //   if (appg.getLoggedIn()) {
  //     return "Cerrar sesion";
  //   }

  //   return "Iniciar sesion";
  // };

  // logout = () => {
  //   if (appg.getLoggedIn()) {
  //     appg.clear();
  //     if (this.props.onLogout) {
  //       this.props.onLogout();
  //     }
  //   }
  // };

  render() {
    // console.log('Header.render(): ', window.location.pathname);
    return (
      <div
        className="ui menu"
        style={{
          backgroundColor: "#121212",
          backgroundImage: `url("https://noticias.fpfch.gob.mx/wp-content/uploads/2022/07/Cabezal714x119_Color.png")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          height: 80,
        }}
      >
        <Link to="/" className="header item" style={{ color: "#fff" }}>
          <i className="ui icon home" />
        </Link>
        <div className="right item" style={{ color: "#fff" }}>
          {/* <i className="ui icon user" /> */}
          <label style={{ cursor: "pointer" }} onClick={this.logout}>
            {/* {this.loginLogoutLabel()} */}
          </label>
        </div>
      </div>
    );
  }
}

export default Header;
